<script>
  import Ticket from "./Ticket.svelte";

  export let tickets, user;
</script>

<section>
  {#if tickets}
    <header>
      <h2>Bilhetes</h2>
      <div class="legend">
        <span class="leg not-used">- Disponível</span>
        <span class="leg used">- Indisponível</span>
        <span class="leg mine">- Comprado</span>
      </div>
    </header>
    <ul class="grid">
      {#each tickets as ticket}
        <li class="grid-item">
          <Ticket {ticket} mine={ticket.user == user} on:ticketNumber />
        </li>
      {/each}
    </ul>
  {/if}
</section>

<style>
  section {
    position: relative;
    margin: 3rem auto;
    width: 90%;
    max-width: 960px;
  }
  .legend {
    position: relative;
    display: flex;
    justify-content: space-evenly;
    font-size: 1rem;
  }
  .leg {
    position: relative;
  }

  .leg::before {
    content: "";
    position: absolute;
    left: -2.5rem;
    top: -0.5rem;
    width: 2rem;
    height: 2rem;
  }
  .used::before {
    background: var(--pink);
  }
  .not-used::before {
    background: var(--green);
  }
  .mine::before {
    background: var(--neutral);
  }
  .grid {
    position: relative;
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(64px, 1fr));
    grid-auto-rows: 1fr;
    grid-gap: 5px;
  }

  .grid::before {
    content: "";
    width: 0;
    padding-bottom: 100%;
    grid-row: 1 / 1;
    grid-column: 1 / 1;
  }

  .grid > *:first-child {
    grid-row: 1 / 1;
    grid-column: 1 / 1;
  }

  .grid-item {
    margin: 0;
    padding: 0;
  }
</style>
